import {Fragment, useEffect} from 'react';

const DefaultOptions = {
    passive: false,
    capture: false,
};

export const withOptions = (listener, options = DefaultOptions) => ({
    listener,
    ...DefaultOptions,
    ...(typeof options === 'boolean' ? {capture: true} : options),
});

const getType = name => name.substring(2).toLowerCase();

const EventListener = ({target, name, listener, passive, capture}) => {
    useEffect(
        () => {
            const type = getType(name);
            const options = {passive, capture};

            target.addEventListener(type, listener, options);

            return () => {
                target.removeEventListener(type, listener, options);
            };
        },
        [target, name, listener, passive, capture],
    );

    return null;
};

const EventListenerController = ({target, children, ...events}) => (
    <Fragment>
        {Object.entries(events).map(([name, listener]) => {
            const props = typeof listener === 'function' ? withOptions(listener) : listener;

            return <EventListener key={name} target={target} name={name} {...props} />;
        })}
        {children}
    </Fragment>
);

export default EventListenerController;
